module.exports = __webpack_public_path__ + "img/logo-ans.90fd6039.png";